var render = function (_h,_vm) {var _c=_vm._c;return _c('el-row',{staticClass:"cmp-container"},[_c('el-col',{staticClass:"label",attrs:{"span":6}},[_vm._v(_vm._s(_vm.props.title))]),_c('el-col',{attrs:{"span":17}},[_vm._t("default")],2),_c('el-col',{staticClass:"icon-wrapper",attrs:{"span":1}},[_vm._t("action")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }